module.exports = {
	"articleTitle1": "Our Town - ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Sadako Japanese Restaurant",
	"articleLink1": "https://www.michigandaily.com/content/our-town",
	"articleLink2": "https://www.michigandaily.com/section/arts/boaa-sadako",
	"articleSnippet1": "Dec 2, 2004 ... Tuesday nights are popular at the restaurant/bar, with chicken wings ... new \nrestaurants like Sadako Japanese Restaurant, South University is ...",
	"articleSnippet2": "Apr 3, 2016 ... And when it comes to sushi consumption, affordability and ... That's why Sadako \nhas been named Ann Arbor's best sushi restaurant; it allows for ...",
	"foodRecommendations": [
		{
			"text": "Really good vegetarian sushi options - I suggest the Green Grass Roll.",
			"person": "Anon"
		}
	],
	"articleTitle2": "Best Sushi: Sadako ",
	"address": "1321 S University Ave, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170406/smk.BOAA_.CharleysRicksPizzaHouseSadako.4.6.17203.jpg?itok=hC4wnozB",
			"author": "Sindu Kilaru",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.27519,
		"lng": -83.732448
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/sadako.json
// module id = 965
// module chunks = 0